import * as fromDatatype from '../datatype-library';

export interface bl_wf_issue_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  guid_parent: fromDatatype.GuidDataFieldInterface;
  title: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  issue_key: fromDatatype.VarcharDatatypeInterface;
  content_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  guid_comp: fromDatatype.GuidDataFieldInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  guid_store: fromDatatype.GuidDataFieldInterface;
  guid_profit_center: fromDatatype.GuidDataFieldInterface;
  guid_segment: fromDatatype.GuidDataFieldInterface;
  guid_project: fromDatatype.GuidDataFieldInterface;
  guid_dimension: fromDatatype.GuidDataFieldInterface;
  guid_tenant: fromDatatype.GuidDataFieldInterface;
  priority: fromDatatype.VarcharDatatypeInterface;
  summary: fromDatatype.VarcharDatatypeInterface;
  issue_number: fromDatatype.VarcharDatatypeInterface;
  target_start_date: fromDatatype.TimestampTzDatatypeInterface;
  target_end_date: fromDatatype.TimestampTzDatatypeInterface;
  actual_start_date: fromDatatype.TimestampTzDatatypeInterface;
  actual_end_date: fromDatatype.TimestampTzDatatypeInterface;
  calculated_start_date: fromDatatype.TimestampTzDatatypeInterface;
  calculated_end_date: fromDatatype.TimestampTzDatatypeInterface;
  baseline_start_date: fromDatatype.TimestampTzDatatypeInterface;
  baseline_end_date: fromDatatype.TimestampTzDatatypeInterface;
  billing_currency: fromDatatype.VarcharDatatypeInterface;
  billing_amount: fromDatatype.BigIntegerDatatypeInterface;
  cost_currency: fromDatatype.VarcharDatatypeInterface;
  cost_amount: fromDatatype.BigIntegerDatatypeInterface;
  story_point: fromDatatype.BigIntegerDatatypeInterface;
  manday_target: fromDatatype.BigIntegerDatatypeInterface;
  manday_actual: fromDatatype.BigIntegerDatatypeInterface;
  manday_allocated: fromDatatype.BigIntegerDatatypeInterface;
  manday_biling: fromDatatype.VarcharDatatypeInterface;
  issue_status: fromDatatype.VarcharDatatypeInterface;
  wf_project_guid: fromDatatype.GuidDataFieldInterface;
  wf_user_guid: fromDatatype.GuidDataFieldInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  main_assignee: fromDatatype.GuidDataFieldInterface;
  main_reporter: fromDatatype.GuidDataFieldInterface;
  contact_hdr_guid: fromDatatype.GuidDataFieldInterface;
  issue_type_guid: fromDatatype.GuidDataFieldInterface;
  pic_login_guid: fromDatatype.GuidDataFieldInterface;
  pic_type:  fromDatatype.VarcharDatatypeInterface;
  pic_group_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_0_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_1_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_2_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_3_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_4_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_5_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_6_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_7_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_8_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_9_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_10_guid: fromDatatype.GuidDataFieldInterface;
  sprint_hdr_guid: fromDatatype.GuidDataFieldInterface;
  sprint_name: fromDatatype.VarcharDatatypeInterface;
  tenant_code: fromDatatype.VarcharDatatypeInterface;
}

export class bl_wf_issue_hdr_RowClass
  implements bl_wf_issue_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  guid_parent: fromDatatype.GuidDataFieldInterface;
  title: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  issue_key: fromDatatype.VarcharDatatypeInterface;
  content_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  guid_comp: fromDatatype.GuidDataFieldInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  guid_store: fromDatatype.GuidDataFieldInterface;
  guid_profit_center: fromDatatype.GuidDataFieldInterface;
  guid_segment: fromDatatype.GuidDataFieldInterface;
  guid_project: fromDatatype.GuidDataFieldInterface;
  guid_dimension: fromDatatype.GuidDataFieldInterface;
  guid_tenant: fromDatatype.GuidDataFieldInterface;
  priority: fromDatatype.VarcharDatatypeInterface;
  summary: fromDatatype.VarcharDatatypeInterface;
  issue_number: fromDatatype.VarcharDatatypeInterface;
  target_start_date: fromDatatype.TimestampTzDatatypeInterface;
  target_end_date: fromDatatype.TimestampTzDatatypeInterface;
  actual_start_date: fromDatatype.TimestampTzDatatypeInterface;
  actual_end_date: fromDatatype.TimestampTzDatatypeInterface;
  calculated_start_date: fromDatatype.TimestampTzDatatypeInterface;
  calculated_end_date: fromDatatype.TimestampTzDatatypeInterface;
  baseline_start_date: fromDatatype.TimestampTzDatatypeInterface;
  baseline_end_date: fromDatatype.TimestampTzDatatypeInterface;
  billing_currency: fromDatatype.VarcharDatatypeInterface;
  billing_amount: fromDatatype.BigIntegerDatatypeInterface;
  cost_currency: fromDatatype.VarcharDatatypeInterface;
  cost_amount: fromDatatype.BigIntegerDatatypeInterface;
  story_point: fromDatatype.BigIntegerDatatypeInterface;
  manday_target: fromDatatype.BigIntegerDatatypeInterface;
  manday_actual: fromDatatype.BigIntegerDatatypeInterface;
  manday_allocated: fromDatatype.BigIntegerDatatypeInterface;
  manday_biling: fromDatatype.VarcharDatatypeInterface;
  issue_status: fromDatatype.VarcharDatatypeInterface;
  wf_project_guid: fromDatatype.GuidDataFieldInterface;
  wf_user_guid: fromDatatype.GuidDataFieldInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  main_assignee: fromDatatype.GuidDataFieldInterface;
  main_reporter: fromDatatype.GuidDataFieldInterface;
  contact_hdr_guid: fromDatatype.GuidDataFieldInterface;
  issue_type_guid: fromDatatype.GuidDataFieldInterface;
  pic_login_guid: fromDatatype.GuidDataFieldInterface;
  pic_type:  fromDatatype.VarcharDatatypeInterface;
  pic_group_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_0_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_1_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_2_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_3_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_4_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_5_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_6_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_7_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_8_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_9_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_10_guid: fromDatatype.GuidDataFieldInterface;
  sprint_hdr_guid: fromDatatype.GuidDataFieldInterface;
  sprint_name: fromDatatype.VarcharDatatypeInterface;
  tenant_code: fromDatatype.VarcharDatatypeInterface;

}
